import React, { useEffect, useState } from 'react'; 
import { Box, Typography, Grid, CircularProgress } from '@mui/material';
import BannerSlider from './Components/BannerSlider';
import EventCard from './Components/EventCard';
import NetworkCards from './Components/NetworkCards';
import { CustomButton } from '../../v2/MUI_custom_component';
import { useSelector } from 'react-redux';
import { getNetworkListAction, getNetworkSummaryAction } from './API/Action';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import StickyEntity from '../Common/Entity/StickyEntity';

const MyNetworkModule = () => {
    const [selectedTab, setSelectedTab] = useState(0);
    const [loadingNetwork, setLoadingNetwork] = useState(false);
    const [networkListData, setNetworkListData] = useState(null);
    const [summaryData, setSummaryData] = useState(null);
    const [roleFilters, setRoleFilters] = useState([]);
    const [loadingSummary, setLoadingSummary] = useState(false);
    const { sliders, summary_card : summaryCards } = summaryData || {};


    const { selectedSupplierData, selectedSupplier: selectedManufacturer, selectedEntity: selectedCompanyEntity } = useSelector(
        (state) => state.entityReducer
    );
    const rawNetworkList = networkListData?.network_list;
    const badgeText = rawNetworkList && rawNetworkList[selectedTab]?.data?.badge_text || '';
    const role_image = rawNetworkList && rawNetworkList[selectedTab]?.data?.src || '';
    const networkList = rawNetworkList ? rawNetworkList.flatMap(network => 
        (network.data.network_cards || []).map(card => ({
        ...card,
            role: network.display_name.toLowerCase().replace(' ', '-'),
            display_role: network.display_name,
            network_type_id: network.id
        }))
    ) : [];
    
    const networkTypes = rawNetworkList ? rawNetworkList.map(network => ({
        id: network.id,
        display_name: network.display_name,
        badge_text: network.data.badge_text
    })) : [];

    const handleTabChange = (tabIndex) => {
        setSelectedTab(tabIndex);
    };
    
    
    const getNetworkList = async () => {
        const payload = {
          manufacturer_id: selectedManufacturer,
          company_esi_id: selectedCompanyEntity,
        };
        setLoadingNetwork(true);
        const { data, error, message } = await getNetworkListAction(payload);
        setLoadingNetwork(false);
                    if (!error) {
                            setNetworkListData(data);
                            // Extract filters from data.filters and store in state
                            if (data?.filters && data.filters.length > 0) {
                                setRoleFilters(data.filters || []);
                            } else {
                                setRoleFilters([]);
                            }
                } else {
                    return toast.error(message);
                }
    };
    const getNetworkSummary = async () => {
        const payload = {
          manufacturer_id: selectedManufacturer,
          company_esi_id: selectedCompanyEntity,
        };
        setLoadingSummary(true);
        const { data, error, message } = await getNetworkSummaryAction(payload);
        setLoadingSummary(false);
        if (!error) {
          setSummaryData(data);
        } else {
          return toast.error(message);
        }
    };
    useEffect(() => {
        if (selectedManufacturer && selectedCompanyEntity) {
            getNetworkSummary();
            getNetworkList();
        }
    }, [selectedManufacturer, selectedCompanyEntity]);

    const currentEventCard = summaryCards && summaryCards.length > 0 
        ? (summaryCards[selectedTab] || summaryCards[0])
        : null;
    const navigate = useNavigate();
    const isEntityEnabled = selectedSupplierData?.entity_enabled;
  
    return (
        <>
            <StickyEntity />
            <Box sx={{ mt: {xs : isEntityEnabled ? '96px': 0, md: 0 }, p: 2, display: 'flex', flexDirection: 'column', gap: { xs:1, md:2 } }}>
                <Grid container spacing={2}>
                    {!loadingSummary ? (
                        <>
                        {sliders && sliders.length > 0 &&  (
                            <Grid item xs={12} md={6}>
                                <BannerSlider sliders={sliders} />
                            </Grid>
                        )}
                        <Grid item xs={12} md={6}>
                            {currentEventCard && <EventCard eventCard={currentEventCard} />}
                            {currentEventCard?.data?.onboard_buyer_module?.show_button && (
                                <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <Typography variant="body1">
                                    {currentEventCard?.data?.onboard_buyer_module?.text || "Onboard new members"}
                                    </Typography>
                                    {currentEventCard?.data?.onboard_buyer_module?.show_button && (
                                        <CustomButton
                                            variant="filled"
                                            color="primary"
                                            size="medium"
                                            label="Onboard"
                                            onClick={() => navigate('/onboard-buyer')}
                                        />
                                    )}
                                </Box>
                            )}
                        </Grid>
                        </>
                    ) : (
                        <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', py: 2 }}>
                            <Typography variant="body1" sx={{ p: 2 }}>
                                Loading ... 
                            </Typography>
                            <CircularProgress size={20} sx={{ mr: 1 }} />
                        </Box>
                    )}
                </Grid>
                
                {!loadingNetwork ? (
                    <NetworkCards 
                        networkCards={networkList}
                        networkTypes={networkTypes}
                        onTabChange={handleTabChange}
                        selectedTab={selectedTab}
                        badgeText={badgeText}
                        role_image = {role_image}
                        selectedCompanyEntity={selectedCompanyEntity}
                        selectedManufacturer={selectedManufacturer}
                        roleFilters={roleFilters}
                    />
                ) : (
                    <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', py: 2 }}>
                        <Typography variant="body1" sx={{ p: 2 }}>
                            Loading network data... 
                        </Typography>
                        <CircularProgress size={20} sx={{ mr: 1 }} />
                    </Box>
                )}
            </Box>
        </>
    );
};

export default MyNetworkModule;